import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserSummary } from '../../users/user-summary.model';
import { User } from '../../users/user.model';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../confirm-dialog/confirm-dialog.component';
import { UserService } from '../../users/user.service';
import { ProcessorCloserReassignmentService } from '../processor-closer-reassignment.service';
import { Reassignment, ReassignmentDto, IgnoredProcessorCloserReassignment } from '../reassignment';
import { UwReshuffleDialogComponent } from '../../uw-reshuffle-dialog/uw-reshuffle-dialog.component';

@Component({
    selector: 'app-pending-processor-pipeline-reassignment',
    templateUrl: './pending-processor-pipeline-reassignment.component.html',
    styleUrls: ['./pending-processor-pipeline-reassignment.component.css']
})
export class PendingProcessorPipelineReassignmentComponent implements OnInit {
    @Output() pendingLoanCount = new EventEmitter<any>();

    public pendingProcessorReassignmentForm: FormGroup;
    public userControl = new FormControl();
    public reassignmentMethodControl = new FormControl();
    public pendingLoanCountControl = new FormControl();
    public searchControl = new FormControl();
    public searchByControl = new FormControl();
    public isCheckedControl = new FormControl();
    public persona = null;
    public closerUsers: UserSummary[];
    public processorUsers: User[];
    public reassignmentMethodValue = null;
    public loanList = [];
    public allLoanList = [];
    public selectedLoans = [];
    public filteredLoans = [];
    public tempLoanList = [];
    public isSortedByLoan = false;
    public isSortedByMilestone = false;
    public isSortedByUser = false;
    public isSortedByLoanOfficer = false;
    public loanCount = 0;
    public refreshClicked: false;
    public isAllSelected = false;
    public reAssign = false;
    public hasError = false;
    public assignedLoans = [];
    public unAssignedLoans = [];
    public successErrorMessage: string = "";
    public inputMessage: string = "";
    public isLoading: boolean = false;
    public searchNewUser: string = null;
    public selectedProcessors = [];
    public activeProcessor = [];

    public searchColumns = [
        { name: 'Loan Number', value: 'loanNumber' },
        { name: 'Last Completed Milestone', value: 'lastCompletedMilestone' },
        { name: 'Invalid Processor', value: 'user' },
        { name: 'Loan Officer', value: 'loanOfficer' }
    ]

    constructor(
        private fb: FormBuilder,
        public userService: UserService,
        public processorCloserReassignmentService: ProcessorCloserReassignmentService,
        public dialog: MatDialog
    ) {
        this.createForm();
    }

    async ngOnInit() {
        this.isLoading = true;
        this.inputMessage = "Fetching pending loans, please wait...";
        this.successErrorMessage = "";
        await this.userService.getUsersByPersona('Processor').then(
            result => {
                if (result != null && result != undefined && result.length > 0) {
                    this.processorUsers = JSON.parse(JSON.stringify(result));
                    this.processorUsers.sort((a, b) => (a.firstName + ' ' + a.lastName).localeCompare(b.firstName + ' ' + b.lastName));
                    this.activeProcessor = JSON.parse(JSON.stringify(this.processorUsers));
                }
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
            });

        this.getPendingLoans();
        this.inputMessage = "";
        this.persona = 'Processor';
        this.pendingProcessorReassignmentForm.get("isCheckedControl").setValue(false);
        this.isAllSelected = false;
        this.selectedLoans = [];
        this.filteredLoans = [];
        this.tempLoanList = [];
    }

    createForm() {
        this.pendingProcessorReassignmentForm = this.fb.group({
            searchLoan: this.fb.group({
                searchControl: [null],
                searchByControl: [null]
            }),
            pendingLoanCountControl: [null],
            isCheckedControl: [null],
            userControl: [null, Validators.required]
        });
    }

    async getPendingLoans() {
        await this.processorCloserReassignmentService.getProcessorPendingLoans().then(
            loans => {
                if (loans != null && loans != undefined) {
                    if (loans.length > 0) {
                        this.loanList = JSON.parse(JSON.stringify(loans));
                        this.loanList.forEach(loan => {
                            loan.isChecked = false;
                        })
                        this.allLoanList = JSON.parse(JSON.stringify(loans));
                        this.allLoanList.forEach(loan => {
                            loan.isChecked = false;
                        })
                    }
                    this.loanCount = this.loanList.length;
                }
                this.pendingLoanCount.emit(this.loanCount);
                this.isLoading = false;
            }).catch(error => {
                console.log(error)
                this.isLoading = false;
            });
    }

    async reassign() {
        if (!this.pendingProcessorReassignmentForm.get("userControl").valid || this.allLoanList.length <= 0 || this.selectedLoans.length <= 0) {
            this.hasError = true;
            return;
        }
        if (this.allLoanList.length > 0) {
            this.loanList = JSON.parse(JSON.stringify(this.allLoanList));
        }
        this.hasError = false;
        this.inputMessage = "Reassignment in progress, please wait...";
        this.successErrorMessage = "";
        this.isLoading = true;
        var pendingLoans: Array<Reassignment> = JSON.parse(JSON.stringify(this.selectedLoans));

        var index = 0;

        if (pendingLoans.length > 0 && this.selectedProcessors.length > 0) {
            await this.makeReassignment(pendingLoans, index);
        }
    }

    async makeReassignment(pendingLoans, index) {
        var reassignment: ReassignmentDto = new ReassignmentDto();
        reassignment.loan = pendingLoans[index];
        reassignment.users = this.selectedProcessors;

        var loan = JSON.parse(JSON.stringify(pendingLoans[index]))

        await this.processorCloserReassignmentService.makePendingProcessorReassignment(reassignment).then(
            result => {
                if (result.assignedSuccessfully) {
                    this.assignedLoans.push(result.messages[0]);
                    var loanIndex = this.loanList.findIndex(element => {
                        return (element.loanNumber == loan.loanNumber);
                    });
                    if (loanIndex != null && loanIndex != -1) {
                        this.loanList.splice(loanIndex, 1);

                        loanIndex = this.allLoanList.findIndex(element => {
                            return (element.loanNumber == loan.loanNumber);
                        });
                        if (loanIndex != null && loanIndex != -1) {
                            this.allLoanList.splice(loanIndex, 1);
                        }
                    }

                    this.selectLoan(loan);
                    this.loanCount = this.loanList.length;
                    this.pendingLoanCount.emit(this.loanCount);
                }
                else {
                    this.unAssignedLoans.push(loan.loanNumber);
                }

                index++;

                if (pendingLoans.length > index) {
                    this.makeReassignment(pendingLoans, index);
                }
            })
            .catch(error => {
                console.log(error);
                this.isLoading = false;
                this.inputMessage = "";
                this.unAssignedLoans.push(reassignment.loan.pipelineLoanData.fields["Fields.364"]);
                index++;
            });

        if (index == pendingLoans.length) {
            this.isLoading = false;
            this.inputMessage = "";
            var message = "Assignment Processor is complete. See below for a list of loans that did get assigned and those that did not.";
            this.showMessage(message, this.assignedLoans, this.unAssignedLoans);
            this.assignedLoans = [];
            this.unAssignedLoans = [];
            this.checkSelectAllLoansCheckbox();
        }
    }

    confirmDelete(loan: any) {
        const message = "Are you sure you want to ignore this loan from reassignment ?";
        const dialogData = new ConfirmDialogModel("Confirm Action", message);

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: dialogData
        });

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (dialogResult) {
                this.deleteLoan(loan);
            }
        });
    }

    async deleteLoan(loan) {
        var ignoredProcessorCloserReassignment = new IgnoredProcessorCloserReassignment();
        ignoredProcessorCloserReassignment.loanNumber = loan.loanNumber;
        ignoredProcessorCloserReassignment.personaId = loan.personaId;

        this.processorCloserReassignmentService.deletePendingLoan(ignoredProcessorCloserReassignment).then(
            deleted => {
                if (deleted) {
                    var loanIndex = this.loanList.findIndex(element => {
                        return (element.loanNumber == loan.loanNumber);
                    });
                    if (loanIndex != null && loanIndex != -1) {
                        this.loanList.splice(loanIndex, 1);

                        loanIndex = this.allLoanList.findIndex(element => {
                            return (element.loanNumber == loan.loanNumber);
                        });
                        if (loanIndex != null && loanIndex != -1) {
                            this.allLoanList.splice(loanIndex, 1);
                        }
                    }
                    this.loanCount = this.loanList.length;

                    var selectedLoanIndex = this.selectedLoans.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
                    if (selectedLoanIndex != -1) {
                        this.selectedLoans.splice(selectedLoanIndex, 1);
                        this.loanCount = this.selectedLoans.length;
                    }
                    if (this.tempLoanList.length > 0) {
                        var tempLoanListIndex = this.tempLoanList.findIndex(element => { return (element.loanNumber = loan.loanNumber); });
                        if (tempLoanListIndex != -1) {
                            this.tempLoanList.splice(tempLoanListIndex, 1);
                            this.loanCount = this.tempLoanList.length;
                        }
                    }
                    this.pendingLoanCount.emit(this.loanCount);
                    this.checkSelectAllLoansCheckbox();
                }
            });
    }

    async showMessage(message, assignedLoanList, unAssignedLoanList) {
        var dialogData = [{ "message": message, "LoanList": unAssignedLoanList, "AssignedLoanList": assignedLoanList }];

        this.dialog.open(UwReshuffleDialogComponent, {
            width: "400px", height: "auto",
            data: dialogData,
        });
    }

    selectLoan(loan: any) {
        if (this.selectedLoans.length != 0) {
            var loanIndex = this.selectedLoans.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
            if (loanIndex != -1) {
                this.getSelectedLoansUnchecked(loan);
                this.selectedLoans.splice(loanIndex, 1);
            }
            else {
                this.selectedLoans.push(loan);
                this.getSelectedLoansChecked();
            }
        }
        else {
            this.selectedLoans.push(loan);
            this.getSelectedLoansChecked();
        }
        this.checkSelectAllLoansCheckbox();
    }

    sortByLoan() {
        if (!this.isSortedByLoan) {
            this.isSortedByLoan = true;
            this.isSortedByMilestone = false
            this.isSortedByUser = false;
            this.isSortedByLoanOfficer = false;
            this.loanList.sort((a, b) => a.loanNumber.localeCompare(b.loanNumber));
        } else {
            this.isSortedByLoan = false;
            this.loanList.sort((a, b) => a.loanNumber.localeCompare(b.loanNumber)).reverse();
        }

    }

    sortByMilestone() {
        if (!this.isSortedByMilestone) {
            this.isSortedByMilestone = true;
            this.isSortedByUser = false;
            this.isSortedByLoan = false;
            this.isSortedByLoanOfficer = false;
            this.loanList.sort((a, b) => a.lastCompletedMilestone.localeCompare(b.lastCompletedMilestone));
        } else {
            this.isSortedByMilestone = false
            this.loanList.sort((a, b) => a.lastCompletedMilestone.localeCompare(b.lastCompletedMilestone)).reverse();
        }

    }

    sortByUser() {
        if (!this.isSortedByUser) {
            this.isSortedByUser = true;
            this.isSortedByLoan = false;
            this.loanList.sort((a, b) => a.firstName.localeCompare(b.firstName));
        } else {
            this.isSortedByUser = false;
            this.loanList.sort((a, b) => a.firstName.localeCompare(b.firstName)).reverse();
        }
    }

    sortByLoanOfficer() {
        if (!this.isSortedByLoanOfficer) {
            this.isSortedByLoanOfficer = true;
            this.isSortedByLoan = false;
            this.loanList.sort((a, b) => a.loanOfficer.localeCompare(b.loanOfficer));
        } else {
            this.isSortedByLoanOfficer = false;
            this.loanList.sort((a, b) => a.loanOfficer.localeCompare(b.loanOfficer)).reverse();
        }
    }

    searchTable() {        
        if (this.tempLoanList.length > 0) {
            this.loanList = JSON.parse(JSON.stringify(this.tempLoanList));
            this.filteredLoans.length = 0;
        }
        var searchLoanFormGroup = this.pendingProcessorReassignmentForm.controls.searchLoan;
        var searchByControl = searchLoanFormGroup.get("searchByControl").value;
        var searchControl = searchLoanFormGroup.get("searchControl").value;
        if (this.filteredLoans.length == 0) {
            if (searchByControl == null || searchControl == null) {
                return;
            }
            if (searchByControl == 'user') {
                this.filteredLoans = this.loanList.filter(element =>
                    (element['firstName'] + ' ' + element['lastName']).toUpperCase().includes(searchControl.toUpperCase())
                );
            }
            else if (searchByControl == 'loanOfficer') {
                this.filteredLoans = this.loanList.filter(element =>
                    element['loanOfficer'].toUpperCase().includes(searchControl.toUpperCase())
                );
            }
            else if (searchByControl == 'loanNumber') {
                this.filteredLoans = this.loanList.filter(element =>
                    element[searchByControl].toUpperCase().includes(searchControl.toUpperCase())
                );
            }
            else {
                this.filteredLoans = this.loanList.filter(element =>
                    element[searchByControl].toUpperCase().includes(searchControl.toUpperCase())
                );
            }
            this.tempLoanList = JSON.parse(JSON.stringify(this.loanList));
            this.loanList = [];
            this.loanList = JSON.parse(JSON.stringify(this.filteredLoans));
        }
        var checkbox = this.pendingProcessorReassignmentForm.get("isCheckedControl");
        checkbox.setValue(false);
        this.isAllSelected = false;
        this.getSelectedLoansChecked();
        this.checkSelectAllLoansCheckbox();
    }

    getSelectedLoansChecked() {
        if (this.selectedLoans.length != 0) {
            this.selectedLoans.forEach(loan => {
                var index = this.loanList.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
                if (index != null && index != -1) {
                    this.loanList[index].isChecked = true;
                    index = this.allLoanList.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
                    if (index != null && index != -1) {
                        this.allLoanList[index].isChecked = true;
                    }
                }
            });
        }
    }

    getSelectedLoansUnchecked(loan: any) {
        if (this.selectedLoans.length != 0) {
            var index = this.loanList.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
            if (index != null && index != -1) {
                this.loanList[index].isChecked = false;
                index = this.allLoanList.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
                if (index != null && index != -1) {
                    this.allLoanList[index].isChecked = false;
                }
            }
        }
    }

    refresh() {
        if (this.tempLoanList.length > 0) {
            this.loanList = [];
            this.loanList = this.allLoanList;
            this.tempLoanList = [];
            this.filteredLoans = [];
            this.getSelectedLoansChecked();
            this.checkSelectAllLoansCheckbox();
            var searchLoanFormGroup = this.pendingProcessorReassignmentForm.controls.searchLoan;
            searchLoanFormGroup.get("searchByControl").setValue("");
            searchLoanFormGroup.get("searchControl").setValue("");
        }
    }

    checkSelectAllLoansCheckbox() {
        var isAllChecked = this.isAllLoansSelected();
        var checkbox = this.pendingProcessorReassignmentForm.get("isCheckedControl");
        checkbox.setValue(isAllChecked);
        this.isAllSelected = isAllChecked;
    }

    isAllLoansSelected = (): boolean => {
        var isAllChecked = false;
        if (this.loanList.length == this.allLoanList.length) {
            for (var i = 0; i < this.allLoanList.length; i++) {
                if (this.allLoanList[i].isChecked) {
                    isAllChecked = true;
                }
                else {
                    isAllChecked = false;
                    break;
                }
            }
        }
        else {
            for (var i = 0; i < this.loanList.length; i++) {
                if (this.loanList[i].isChecked) {
                    isAllChecked = true;
                }
                else {
                    isAllChecked = false;
                    break;
                }
            }
        }
        return isAllChecked;
    }

    selectAll() {

        if (this.loanList.length > 0) {
            if (this.isAllSelected == false) {
                this.loanList.forEach(loan => {
                    loan.isChecked = true;
                });
                this.isAllSelected = true;
                if (this.selectedLoans != null && this.selectedLoans.length > 0) {
                    this.loanList.forEach(loan => {
                        var loanIndex = this.selectedLoans.findIndex(element => { return (element.loanNumber == loan.loanNumber); });
                        if (loanIndex != null && loanIndex == -1) {
                            this.selectedLoans.push(loan);
                        }
                    });
                }
                else {
                    this.selectedLoans = JSON.parse(JSON.stringify(this.loanList));
                }
            }
            else {
                this.loanList.forEach(loan => {
                    loan.isChecked = false;
                    if (this.allLoanList.length > 0) {
                        this.allLoanList.forEach(element => {
                            if (element.loanNumber === loan.loanNumber) {
                                element.isChecked = false;
                            }
                        })
                    }
                });
                this.isAllSelected = false;
                this.selectedLoans = [];
            }
        }
    }

    onSearchChange() {
        if (this.searchNewUser) {
            this.activeProcessor = this.processorUsers.filter(value => value.name.toLowerCase().includes(this.searchNewUser.toLowerCase()));
            this.selectedProcessors.forEach(value => {
                if (!this.activeProcessor.includes(value)) {
                    this.activeProcessor.push(value)
                }
            });
        }
        else {
            this.activeProcessor = this.processorUsers;
        }
    }

    onSelectionChange(event) {
        if (event.value.length > 0) {
            event.value.forEach(val => {
                if (!this.selectedProcessors.includes(val)) {
                    this.selectedProcessors.push(val);
                }
            })
            let tempUsers = [...this.selectedProcessors];
            tempUsers.forEach((val, index) => {
                if (!event.value.includes(val)) {
                    this.selectedProcessors.splice(index, 1);
                }
            })
        }
        else {
            this.selectedProcessors = [];
            this.reAssign = false;
        }

        if (this.selectedProcessors.length > 0) {
            this.reAssign = true;
        }
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/processor-closer-pipeline-reassignment/pending-processor-pipeline-reassignment/pending-processor-pipeline-reassignment.component.ts